import React from 'react';
import compact from 'lodash/compact';
import { TableList, Typography, TableListActions, DropdownMenuItem, Tooltip, IconButton } from 'seagull';
import { AnchorIconGrayscale, Edit2Liner24, TrashLine, HeartLine } from 'seagull/icons';
import { QboIcon } from "../../components/Integrations/QBO/QboIcon";
import { getAccountantAccessItem } from "./ContactsDashboard.utils";
import styles from "./ContactsDashboardRow.module.scss";
import { contactModel } from "../../models";
import EnterAccountantAccessButton from "../../components/EnterAccountantAccessButton/EnterAccountantAccessButton";
import capitalize from 'lodash/capitalize';
export default function ContactsDashboardRow(props) {
  const {
    contact,
    isQboIntegrated,
    qboCustomerIdToDisplay,
    openContactModal,
    onRequestAccountantAccess,
    onCancelAccountantAccessRequest,
    onRemoveAccountantAccess,
    onGotoClientPortal,
    onRestoreContact,
    onArchiveContact
  } = props;
  const accountantAccessItem = getAccountantAccessItem(contact.accountantAccess);
  const qboCustomerDisplay = contactModel.integratedId(contact) ? qboCustomerIdToDisplay[contactModel.integratedId(contact)] : undefined;
  return /*#__PURE__*/React.createElement(TableList.Row, {
    key: contactModel.id(contact),
    "data-testid": contact.isSample ? 'sample-contact' : "contact-row",
    "data-heapid": contact.isSample ? 'sample-contact' : 'contact',
    items: compact([{
      value: /*#__PURE__*/React.createElement("div", {
        className: styles.companyName
      }, /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true,
        weight: "normal",
        "data-testid": "contact-company-name"
      }, contactModel.companyName(contact)), contact.accountantAccess === contactModel.AccountantAccess.Invited && /*#__PURE__*/React.createElement(EnterAccountantAccessButton, {
        variant: "pending",
        testid: "acc-access-invited-indicator"
      }), contact.accountantAccess === contactModel.AccountantAccess.Active && /*#__PURE__*/React.createElement(EnterAccountantAccessButton, {
        testid: "acc-access-active-indicator",
        onClick: () => onGotoClientPortal(contact)
      }), isQboIntegrated && /*#__PURE__*/React.createElement(QboCustomerMappingIndication, {
        qboCustomerDisplay: qboCustomerDisplay
      }))
    }, {
      value: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true,
        weight: "normal",
        "data-testid": "contact-status"
      }, capitalize(contactModel.status(contact))))
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true,
        "data-testid": "contact-contact-name"
      }, "".concat(contactModel.firstName(contact), " ").concat(contactModel.lastName(contact)))
    }, {
      value: /*#__PURE__*/React.createElement("div", {
        "data-testid": "contact-contact-details"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        ellipsis: true
      }, contactModel.email(contact)), /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        skin: "secondary"
      }, contactModel.phone(contact)))
    }]),
    actionColumn: /*#__PURE__*/React.createElement(TableListActions, {
      testId: contact.isSample ? 'sample-contact-actions' : 'table-list-actions',
      btnHeapId: contact.isSample ? 'sample-contact-view-btn' : 'contact-view-btn',
      onClickButton: () => openContactModal(contact)
    }, compact([/*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: "view",
      iconStart: /*#__PURE__*/React.createElement(Edit2Liner24, null),
      onClick: () => openContactModal(contact),
      "data-testid": "table-list-actions-menu-item",
      disabled: !contactModel.isEditable(contactModel.edit(contact)),
      tooltipProps: contactModel.isEditable(contactModel.edit(contact)) || contactModel.isSample(contact) ? undefined : {
        title: 'As this client is already an active member of Anchor, their contact details can only be modified by them'
      }
    }, "Edit"), contactModel.isActive(contactModel.status(contact)) ? /*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: "archive",
      iconStart: /*#__PURE__*/React.createElement(TrashLine, null),
      onClick: () => onArchiveContact(contact),
      "data-testid": "actions-archive",
      disabled: contactModel.hasSignedAgreements(contact) || contactModel.isSample(contact),
      skin: "error",
      tooltipProps: contactModel.hasSignedAgreements(contact) ? {
        title: 'Clients with active agreements cannot be archived',
        placement: 'bottom'
      } : {}
    }, "Archive") : /*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: "restore",
      iconStart: /*#__PURE__*/React.createElement(HeartLine, null),
      onClick: () => onRestoreContact(contact),
      "data-testid": "actions-restore"
    }, "Restore"), accountantAccessItem && /*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: "accountant",
      skin: accountantAccessItem.skin,
      "data-testid": "acc-access-".concat(accountantAccessItem.id),
      iconStart: /*#__PURE__*/React.createElement(AnchorIconGrayscale, null),
      onClick: () => {
        if (accountantAccessItem.id === 'request') {
          contactModel.customerId(contact) && onRequestAccountantAccess(contact);
        } else if (accountantAccessItem.id === 'cancel') {
          onCancelAccountantAccessRequest(contact);
        } else {
          onRemoveAccountantAccess(contact);
        }
      }
    }, accountantAccessItem.text)]))
  });
}

const QboCustomerMappingIndication = props => {
  const {
    qboCustomerDisplay
  } = props;
  const tooltipTitle = qboCustomerDisplay ? "Synced with: ".concat(qboCustomerDisplay) : 'Contact is not mapped to QuickBooks Online';
  const intent = qboCustomerDisplay ? 'success' : 'pending';
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "qbo-customer-map-indication"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: /*#__PURE__*/React.createElement("div", {
      "data-testid": "qbo-customer-map-tooltip"
    }, tooltipTitle)
  }, /*#__PURE__*/React.createElement(IconButton, {
    cursorDefault: true,
    skin: "transparent"
  }, /*#__PURE__*/React.createElement(QboIcon, {
    intent: intent
  }))));
};